import './Radio.scoped.scss'

export default function Radio({ label, ...rest }) {
  return <label>
    <input type="radio" {...rest} />
    <span>{label}</span>
  </label>
}

